module.exports = __webpack_public_path__ + "static/img/logo-right.bdf9a87.png";